import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const SignupPage = Loadable(lazy(() => import('pages/auth/Signup')));
const ForgotPasswordPage = Loadable(lazy(() => import('pages/auth/ForgotPassword')));
const ResetPasswordConfirmPage = Loadable(lazy(() => import('pages/auth/ResetPasswordConfirm')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  // No `path` here, same reasoning as MainRoutes: every child below is
  // already an absolute path (leading '/'), so this parent's own '/' was
  // dead weight that would otherwise contest bare '/' against PublicRoutes.
  children: [
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/signup',
      element: <SignupPage />
    },
    {
      path: '/forgot-password',
      element: <ForgotPasswordPage />
    },
    {
      path: '/reset-password/confirm',
      element: <ResetPasswordConfirmPage />
    }
  ]
};

export default LoginRoutes;
